import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import DismissibleBanner from "./DismissibleBanner";
var getClassName = getClassNameFactory("DismissibleBanner");
export default /*#__PURE__*/(function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren) {
    var readData, childrenClass, headingClass, textClass, rehydrationProps, childrenNode, children;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            readData = function readData(prop) {
              var data = domNode.getAttribute("data-".concat(prop));
              return data ? JSON.parse(data) : null;
            };

            childrenClass = getClassName({
              descendantName: "links"
            });
            headingClass = getClassName({
              descendantName: "heading"
            });
            textClass = getClassName({
              descendantName: "text"
            });
            rehydrationProps = {
              alreadySeenCookieName: domNode.getAttribute("data-already-seen-cookie-name"),
              alreadySeenCookieExpectedValue: domNode.getAttribute("data-already-seen-cookie-expected-value"),
              dismissButtonText: domNode.getAttribute("data-dismiss-button-text"),
              closeButtonText: domNode.getAttribute("data-close-button-text"),
              fixed: domNode.getAttribute("data-fixed") === "true",
              // @ts-ignore
              heading: domNode.querySelector(".".concat(headingClass)).textContent,
              hideIfAlreadySeen: domNode.getAttribute("data-hide-if-already-seen") === "true",
              // @ts-ignore
              text: domNode.querySelector(".".concat(textClass)).textContent,
              validParentDomains: readData("valid-parent-domains")
            };
            childrenNode = domNode.querySelector(".".concat(childrenClass));

            if (!childrenNode) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return rehydrateChildren(childrenNode);

          case 9:
            _context.t0 = _context.sent;
            _context.next = 13;
            break;

          case 12:
            _context.t0 = null;

          case 13:
            children = _context.t0;
            return _context.abrupt("return",
            /*#__PURE__*/
            // @ts-ignore
            React.createElement(DismissibleBanner, rehydrationProps, children));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
})();